import { render } from "./Header.vue?vue&type=template&id=2672f38b"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=2672f38b&lang=css"
script.render = render

export default script